(function () {
  const root = document.querySelector("[data-tune-widget]");
  if (!root) return;

  function money(n) {
    return (Math.round(n * 100) / 100).toLocaleString(undefined, {
      style: "currency",
      currency: "USD"
    });
  }

  function moneyLabel(n) {
    if (typeof n !== "number") return "";
    return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function toNumber(value) {
    if (value === "" || value == null) return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function normalizeVin(value) {
    return String(value || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function isValidVin(value) {
    return /^[A-HJ-NPR-Z0-9]{17}$/.test(normalizeVin(value));
  }

  function pctToCeiling(value, ceiling) {
    if (value == null || ceiling <= 0) return 0;
    return Math.max(0, Math.min(100, (value / ceiling) * 100));
  }

  function renderSpecCard({ make, year, model, stageName, stageData }) {
    const { factoryHp, tunedHp, factoryTq, tunedTq, price } = stageData;

    const hpGain = (tunedHp ?? 0) - (factoryHp ?? 0);
    const tqGain = (tunedTq ?? 0) - (factoryTq ?? 0);

function stageTargetPct(stageName) {
  if (stageName === "Stage 1") return 0.65;
  if (stageName === "Stage 2") return 0.85;
  return 0.75; // fallback
}

function stageCeiling(tuned, stageName) {
  const target = stageTargetPct(stageName);
  const t = Number(tuned);
  if (!Number.isFinite(t) || t <= 0) return 1;

  let ceiling = t / target;

  // small headroom so it doesn't visually slam the edge
  ceiling *= 1.03;

  // round to nice number (nearest 10)
  return Math.ceil(ceiling / 10) * 10;
}

const HP_CEILING = stageCeiling(tunedHp, stageName);
    const TQ_CEILING = stageCeiling(tunedTq, stageName);
    const hpBasePct = pctToCeiling(factoryHp, HP_CEILING);
    const hpTunedPct = pctToCeiling(tunedHp, HP_CEILING);

    const tqBasePct = pctToCeiling(factoryTq, TQ_CEILING);
    const tqTunedPct = pctToCeiling(tunedTq, TQ_CEILING);
    const contactHref = `/pages/contact-us?tune=${encodeURIComponent(`${year} ${make} ${model} ${stageName}`)}`;

    const statRow = ({ label, factory, tuned, unit, basePct, tunedPct, gain }) => {
      if (factory == null || tuned == null) return "";
      const gainWidth = Math.max(0, tunedPct - basePct);

      return `
        <section class="tw-stat">
          <div class="tw-stat__head">
            <div class="tw-stat__label">${label}</div>

            <div class="tw-stat__vals">
              <div class="tw-val">
                <div class="tw-val__kicker">Factory</div>
                <div class="tw-val__num">${factory}<span class="tw-unit"> ${unit}</span></div>
              </div>

              <div class="tw-arrow" aria-hidden="true">→</div>

              <div class="tw-val tw-val--tuned">
                <div class="tw-val__kicker">Tuned</div>
                <div class="tw-val__num">${tuned}<span class="tw-unit"> ${unit}</span></div>
              </div>
            </div>
          </div>

          <div class="tw-bar" role="img" aria-label="${label}: Factory ${factory} ${unit}, Tuned ${tuned} ${unit}, Gain ${gain} ${unit}">
            <div class="tw-bar__track">
              <div class="tw-bar__base" style="width:${basePct}%"></div>
              <div class="tw-bar__tuned" style="width:${tunedPct}%"></div>
              <div class="tw-bar__gainfill" style="left:${basePct}%; width:${gainWidth}%"></div>
            </div>
            <div class="tw-bar__gain">+${gain} ${unit}</div>
          </div>
        </section>
      `;
    };

    return `
      <div class="spec-card tw-card">
        <div class="tw-card__header">
          <h3 class="tw-card__title">${make} ${model} (${year})</h3>
          <div class="tw-card__stage">${stageName}</div>
        </div>

        ${statRow({ label: "Horsepower", factory: factoryHp, tuned: tunedHp, unit: "HP", basePct: hpBasePct, tunedPct: hpTunedPct, gain: hpGain })}
        ${statRow({ label: "Torque",     factory: factoryTq, tuned: tunedTq, unit: "TQ", basePct: tqBasePct, tunedPct: tqTunedPct, gain: tqGain })}

        ${price != null ? `
          <div class="tw-price">
            <div class="tw-price__row tw-price__total">
              <span>Total</span>
              <strong>${money(price)}</strong>
            </div>
            <form class="tw-checkout" data-tune-checkout-form>
              <label class="tw-checkout__label" for="tune-vin">VIN</label>
              <div class="tw-checkout__row">
                <input
                  id="tune-vin"
                  class="tw-checkout__vin"
                  name="vin"
                  type="text"
                  inputmode="latin"
                  autocomplete="off"
                  maxlength="17"
                  placeholder="Enter 17-character VIN"
                  required>
                <button class="tw-checkout__button" type="submit">Checkout with Shopify</button>
              </div>
              <p class="tw-checkout__message" data-tune-checkout-message aria-live="polite"></p>
              <a class="tw-checkout__contact" href="${contactHref}">Need help before checkout?</a>
            </form>
          </div>
        ` : ""}
      </div>
    `;
  }

  const makeSelect = root.querySelector("#make-select");
  const yearSelect = root.querySelector("#year-select");
  const modelSelect = root.querySelector("#model-select");
  const stageButtons = root.querySelector("#stage-buttons");
  const specOutput = root.querySelector("#spec-output");
  const checkoutUrl = root.dataset.tuneCheckoutUrl || "";


function parseTuneDataScript(script) {
  if (!script?.textContent?.trim()) return [];

  const data = JSON.parse(script.textContent);
  if (!Array.isArray(data)) throw new Error("Inline tune data must be an array");
  return data;
}

function resolvePaginatedUrl(nextUrl) {
  if (!nextUrl) return "";

  const url = new URL(nextUrl, window.location.href);
  const current = new URL(window.location.href);

  current.searchParams.forEach((value, key) => {
    if (key !== "page" && !url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });

  return url.href;
}

async function loadInlineVehicleData() {
  const data = parseTuneDataScript(root.querySelector("[data-tune-data-json]"));
  const loadedUrls = new Set([window.location.href]);
  let nextUrl = root.querySelector("[data-tune-data-pagination]")?.dataset.tuneNextUrl || "";

  while (nextUrl) {
    const pageUrl = resolvePaginatedUrl(nextUrl);
    if (!pageUrl || loadedUrls.has(pageUrl)) break;

    loadedUrls.add(pageUrl);

    const res = await fetch(pageUrl, { cache: "no-store" });
    if (!res.ok) throw new Error(`Failed to load tune data page (${res.status})`);

    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const script = doc.querySelector("[data-tune-data-json]");
    data.push(...parseTuneDataScript(script));
    nextUrl = doc.querySelector("[data-tune-data-pagination]")?.dataset.tuneNextUrl || "";
  }

  return data;
}

async function loadVehicleData() {
  if (root.querySelector("[data-tune-data-json]")) {
    return await loadInlineVehicleData();
  }

  const url = root.dataset.tuneDataUrl;
  if (!url) throw new Error("Tune data is not available");

  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error(`Failed to load tune data (${res.status})`);
  return await res.json();
}

  function buildTunesFromVehicleData(data) {
    const tunes = {};

    for (const row of data) {
      const make = row.make?.trim();
      const year = String(row.year);
      const model = row.model?.trim();
      if (!make || !year || !model) continue;

      tunes[make] ??= {};
      tunes[make][year] ??= {};
      tunes[make][year][model] ??= { stages: {} };

      // Stage 1
      const stage1Price = toNumber(row.stage1_price);
      if (stage1Price != null) {
        tunes[make][year][model].stages["Stage 1"] = {
          price: stage1Price,
          priceLabel: moneyLabel(stage1Price),

          factoryHp: toNumber(row.stock_hp),
          tunedHp: toNumber(row.stage1_hp),
          factoryTq: toNumber(row.stock_tq),
          tunedTq: toNumber(row.stage1_tq)
        };
      }

      // Stage 2
      const stage2Price = toNumber(row.stage2_price);
      if (stage2Price != null) {
        tunes[make][year][model].stages["Stage 2"] = {
          price: stage2Price,
          priceLabel: moneyLabel(stage2Price),

          factoryHp: toNumber(row.stock_hp),
          tunedHp: toNumber(row.stage2_hp),
          factoryTq: toNumber(row.stock_tq),
          tunedTq: toNumber(row.stage2_tq)
        };
      }
    }

    return tunes;
  }

let TUNES = {};

(async function init() {
  try {
    const vehicleData = await loadVehicleData();
    TUNES = buildTunesFromVehicleData(vehicleData);
    populateMakes();
  } catch (e) {
    console.error(e);
    // show something helpful in the UI
    const makeSelect = root.querySelector("#make-select");
    if (makeSelect) {
      makeSelect.innerHTML = `<option value="">Failed to load tune data</option>`;
      makeSelect.disabled = true;
    }
  }
})();

  // ===== HELPERS =====
  const resetSelect = (sel, placeholder) => {
    sel.innerHTML = "";
    const opt = document.createElement("option");
    opt.value = "";
    opt.textContent = placeholder;
    sel.appendChild(opt);
  };

  const setDisabled = (sel, disabled) => {
    sel.disabled = disabled;
  };

  function populateMakes() {
    resetSelect(makeSelect, "Select Make");
    Object.keys(TUNES).forEach((make) => {
      const opt = document.createElement("option");
      opt.value = make;
      opt.textContent = make;
      makeSelect.appendChild(opt);
    });
  }

  function populateYears(make) {
    resetSelect(yearSelect, "Select Year");
    resetSelect(modelSelect, "Select Model");
    setDisabled(yearSelect, true);
    setDisabled(modelSelect, true);
    stageButtons.style.display = "none";
    specOutput.textContent = "";


    if (!make || !TUNES[make]) return;

    Object.keys(TUNES[make]).sort().forEach((year) => {
      const opt = document.createElement("option");
      opt.value = year;
      opt.textContent = year;
      yearSelect.appendChild(opt);
    });

    setDisabled(yearSelect, false);
  }

  function populateModels(make, year) {
    resetSelect(modelSelect, "Select Model");
    setDisabled(modelSelect, true);
    stageButtons.style.display = "none";
    specOutput.textContent = "";



    if (!make || !year || !TUNES[make]?.[year]) return;

    Object.keys(TUNES[make][year]).sort().forEach((model) => {
      const opt = document.createElement("option");
      opt.value = model;
      opt.textContent = model;
      modelSelect.appendChild(opt);
    });

    setDisabled(modelSelect, false);
  }

  let selected = { make: "", year: "", model: "", stage: "" };

  function renderStages(make, year, model) {
    stageButtons.innerHTML = "";
    stageButtons.style.display = "none";
    specOutput.textContent = "";
    selected.stage = "";

    const node = TUNES[make]?.[year]?.[model];
    if (!node) return;

    if (node.spec) specOutput.textContent = node.spec;

    const stages = node.stages || {};
    const stageNames = Object.keys(stages);
    if (!stageNames.length) return;

    stageButtons.style.display = "";
    const defaultStageName = stages["Stage 2"] ? "Stage 2" : stageNames[0];

    stageNames.forEach((stageName) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tune-stage-btn";
      btn.textContent = stages[stageName].priceLabel
        ? `${stageName} — ${stages[stageName].priceLabel}`
        : stageName;

      btn.addEventListener("click", () => {
        [...stageButtons.querySelectorAll(".tune-stage-btn")].forEach((b) =>
          b.classList.remove("is-active")
        );
        btn.classList.add("is-active");

        selected.stage = stageName;

        specOutput.innerHTML = renderSpecCard({
          make,
          year,
          model,
          stageName,
          stageData: stages[stageName]
        });

      });

      stageButtons.appendChild(btn);

      if (stageName === defaultStageName) {
        btn.click();
      }
    });
  }

  function setCheckoutMessage(form, message, state = "") {
    const messageEl = form.querySelector("[data-tune-checkout-message]");
    if (!messageEl) return;

    messageEl.textContent = message;
    messageEl.dataset.state = state;
  }

  specOutput.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-tune-checkout-form]");
    if (!form) return;

    event.preventDefault();

    const vinInput = form.querySelector("[name='vin']");
    const submitButton = form.querySelector("button[type='submit']");
    const vin = normalizeVin(vinInput?.value);

    if (!isValidVin(vin)) {
      setCheckoutMessage(form, "Enter a valid 17-character VIN.", "error");
      vinInput?.focus();
      return;
    }

    if (!checkoutUrl) {
      setCheckoutMessage(form, "Checkout is not configured yet. Please contact us.", "error");
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Creating checkout...";
    setCheckoutMessage(form, "", "");

    try {
      const response = await fetch(checkoutUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          make: selected.make,
          year: selected.year,
          model: selected.model,
          stage: selected.stage,
          vin
        })
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.checkoutUrl) {
        throw new Error(result.error || "Checkout could not be created.");
      }

      window.location.href = result.checkoutUrl;
    } catch (error) {
      setCheckoutMessage(form, error.message || "Checkout could not be created.", "error");
      submitButton.disabled = false;
      submitButton.textContent = "Checkout with Shopify";
    }
  });

  // ===== EVENTS =====
  makeSelect.addEventListener("change", (e) => {
    selected.make = e.target.value;
    selected.year = "";
    selected.model = "";
    populateYears(selected.make);
  });

  yearSelect.addEventListener("change", (e) => {
    selected.year = e.target.value;
    selected.model = "";
    populateModels(selected.make, selected.year);
  });

  modelSelect.addEventListener("change", (e) => {
    selected.model = e.target.value;
    renderStages(selected.make, selected.year, selected.model);
  });



  // init
  populateMakes();
})();
